// extracted by mini-css-extract-plugin
export default {"removeButton":"dGD_EOqNzRMoSdJYCDEB"};